<template lang="pug">
div
  .service-limit
    div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('how_many_times_service') }}
    div.text-sm.neutral500--text {{ $t('how_many_times_service_desc') }}
    v-row(no-gutters)
      v-col(cols="12" sm="5")
        v-radio-group(v-model="usageLimitation" :disabled="disabled")
          v-radio(:value="false" color="neutral700")
            template(v-slot:label)
              div.text-md.font-normal.neutral700--text {{ $t('unlimited_times') }}
          v-radio(:value="true" color="neutral700")
            template(v-slot:label)
              div.text-md.font-normal.neutral700--text {{ $t('limited_times') }}

        v-expand-transition
          v-card.round-lg.neutral300.pa-4(v-if="usageLimitation" flat)
            div.text-xs.font-semibold {{ $t('limited_times_desc') }}
            div.d-flex.align-center.mt-2
              div(style="width: 60px")
                v-text-field.text-md.font-normal.round-xl(v-model="usageLimit" placeholder="30" type="number" background-color="basic100" outlined :rules="rules.has_quantity" dense hide-details :disabled="disabled")
              div.text-xs.neutral700--text.ml-2 {{ $t('times_at_one_time') }}

  .patient-schedule
    div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('when_patients_schedule') }}
    div.text-sm.neutral500--text {{ $t('when_patients_schedule_desc') }}
  
    div.text-md.font-medium.neutral700--text.mt-8 {{ $t('patient_must_schedule') }}...
    div.d-flex.align-center
      div(style="width: 60px")
        v-text-field.text-md.font-normal.mt-2.round-xl.inputText(v-model="timeValue" placeholder="3" type="number" outlined :rules="rules.has_quantity" dense height="48" hide-details :disabled="disabled")
      div.ml-2(style="width: 200px")
        v-select.text-md.font-normal.mt-2.round-xl(v-model="timeUnit" :items="types" item-text="text" item-value="value" outlined :rules="rules.not_empty_select" dense attach height="48" hide-details :disabled="disabled")
          template(v-slot:append)
            eva-icon(name="chevron-down-outline" width="20" height="20" style="margin-top: 6px" :fill="$colors.basic700")
      div.text-sm.neutral700--text.ml-4 {{ $t('before_appointment_start') }}

  .booking-fee
    div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('is_booking_fee_required') }}
    v-row(no-gutters)
      v-col(cols="12" sm="5")
        v-radio-group(v-model="bookingFeeRequired" :disabled="disabled")
          v-radio(:value="false" color="neutral700")
            template(v-slot:label)
              div.text-md.font-normal.neutral700--text {{ $t('no') }}
          v-radio(:value="true" color="neutral700")
            template(v-slot:label)
              div.text-md.font-normal.neutral700--text {{ $t('yes') }}
        
        v-expand-transition
          v-card.round-lg.neutral300.pa-4(v-if="bookingFeeRequired" flat)
            div.text-xs.font-semibold {{ $t('booking_fee_desc') }}
            div(style="width: 120px")
              v-text-field.text-md.font-normal.round-xl.mt-2(v-model="bookingFee" placeholder="100.00" type="number" background-color="basic100" :prefix="$currency.symbol" outlined :rules="rules.has_price" dense hide-details :disabled="disabled")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ServiceSettings',
  components: {  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      usageLimitation: false,
      usageLimit: null,
      timeUnit: 'days',
      timeValue: null,
      types: [
        { text: 'Minutes', value: 'minutes' },
        { text: 'Hour', value: 'hours' },
        { text: 'Day', value: 'days' },
        { text: 'Week', value: 'weeks' },
        { text: 'Month', value: 'months' },
      ],
      bookingFeeRequired: false,
      bookingFee: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      service: 'clinic/getService',
    }),
    settingsData () {
      return {
        usage_limit: this.usageLimitation ? this.usageLimit : null,
        preparation_time_value: this.timeValue,
        preparation_time_unit: this.timeUnit,
        booking_fee: this.bookingFeeRequired ? Math.round(this.bookingFee * this.$currency.multiplier) : 0
      }
    }
  },
  watch: {
    settingsData: {
      deep: true,
      handler (val) {
        if (this.disabled) return
        this.$store.commit('clinic/updateTempService', val)
      }
    }
  },
  mounted () {
    if (this.service) {
      this.setData(this.service)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (service) {
      this.usageLimitation = Boolean(service.usage_limit)
      this.usageLimit = service.usage_limit
      this.timeValue = service.preparation_time_value
      this.timeUnit = service.preparation_time_unit
      this.bookingFeeRequired = Boolean(service.booking_fee)
      this.bookingFee = service.booking_fee / this.$currency.multiplier
    },
  }
}
</script>

<style scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.inputText >>> input {
  margin-top: 3px;
  text-align: center;
}
</style>